export default __webpack_public_path__ + "static/media/28_4_0.a67856ec.png";